const  LimitationTypes = {
    FETCH_LIMITATION_START: 'FETCH_LIMITATION_START',
    FETCH_LIMITATION_SUCCESS: 'FETCH_LIMITATION_SUCCESS',
    FETCH_LIMITATION_FAILURE: 'FETCH_LIMITATION_FAILURESS',  
    FETCH_PLANCONFIG_START: 'FETCH_PLANCONFIG_START',
    FETCH_PLANCONFIG_SUCCESS: 'FETCH_PLANCONFIG_SUCCESS',
    FETCH_PLANCONFIG_FAILURE: 'FETCH_PLANCONFIG_FAILURESS',  
    RESET_STATE: 'RESET_STATE'
  };
  
  export default LimitationTypes;
  